var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronRightEnd = function SvgChevronRightEnd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07971 5.13554C3.82096 4.8121 3.8734 4.34013 4.19684 4.08137C4.52029 3.82261 4.99226 3.87505 5.25102 4.1985L7.91768 7.53183C8.13681 7.80575 8.13681 8.19496 7.91768 8.46888L5.25102 11.8022C4.99226 12.1257 4.52029 12.1781 4.19684 11.9193C3.8734 11.6606 3.82096 11.1886 4.07971 10.8652L6.37156 8.00036L4.07971 5.13554ZM8.07971 5.13554C7.82096 4.8121 7.8734 4.34013 8.19684 4.08137C8.52029 3.82261 8.99226 3.87505 9.25102 4.1985L11.9177 7.53183C12.1368 7.80575 12.1368 8.19496 11.9177 8.46888L9.25102 11.8022C8.99226 12.1257 8.52029 12.1781 8.19684 11.9193C7.8734 11.6606 7.82096 11.1886 8.07971 10.8652L10.3716 8.00036L8.07971 5.13554Z",
    fill: "#18191B"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRightEnd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chevron-right-end.d748aa24943c006abccb316eba6bbb10.svg";